import { Host, h } from '@stencil/core';
import classNames from '../../../utils/classnames.utils';
export class AibaAlert {
  constructor() {
    this.defaultTimeout = 2000;
    this.onCloseClick = () => {
      this.displayAlert = false;
    };
    this.onCloseAlertWithTimeout = () => {
      if (this.timeout) {
        if (typeof this.timeout === 'number' || typeof this.timeout === 'string') {
          if (!isNaN(Number(this.timeout))) {
            setTimeout(() => {
              this.onCloseClick();
            }, Number(this.timeout));
          }
        }
        else {
          setTimeout(() => {
            this.onCloseClick();
          }, this.defaultTimeout);
        }
      }
    };
    this.message = undefined;
    this.icon = undefined;
    this.closeicon = undefined;
    this.closeicontype = 'text';
    this.styles = undefined;
    this.classes = undefined;
    this.variant = undefined;
    this.border = undefined;
    this.borderradius = undefined;
    this.alt = undefined;
    this.altText = undefined;
    this.timeout = false;
    this.displayAlert = true;
  }
  render() {
    var _a, _b;
    this.onCloseAlertWithTimeout();
    return (h(Host, null, this.styles && h("style", null, this.styles), this.displayAlert && (h("div", { class: this.getCssClassMap() }, h("div", { class: `alert__body ${this.classes}` }, h("div", { class: "alert__icon" }, (this.icon || this.alt) && h("img", { src: this.icon, alt: (_b = (_a = this.alt) !== null && _a !== void 0 ? _a : this.altText) !== null && _b !== void 0 ? _b : 'image' })), h("div", { class: "alert__content" }, this.alt, h("div", { class: "alert__message" }, this.message)), this.closeicon && (h("a", { class: "alert__close", onClick: this.onCloseClick }, this.closeicontype === 'icon' ? (h("div", { class: "alert__close-icon" }, h("img", { src: this.closeicon }))) : (this.closeicon))))))));
  }
  getCssClassMap() {
    return classNames('alert', this.borderradius && `alert--border-radius`, this.variant && `alert--variant-${this.variant}`, this.border && `alert--border-${this.border}`, this.classes && `${this.classes}`);
  }
  static get is() { return "aiba-alert"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-alert.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-alert.css"]
    };
  }
  static get properties() {
    return {
      "message": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "message",
        "reflect": false
      },
      "icon": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "icon",
        "reflect": false
      },
      "closeicon": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "closeicon",
        "reflect": false
      },
      "closeicontype": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "'text' | 'icon'",
          "resolved": "\"icon\" | \"text\"",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "closeicontype",
        "reflect": false,
        "defaultValue": "'text'"
      },
      "styles": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      },
      "classes": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "classes",
        "reflect": false
      },
      "variant": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "variant",
        "reflect": false
      },
      "border": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "'1px' | '2px' | '3px'",
          "resolved": "\"1px\" | \"2px\" | \"3px\"",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "border",
        "reflect": false
      },
      "borderradius": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "borderradius",
        "reflect": false
      },
      "alt": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "alt",
        "reflect": false
      },
      "altText": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "alt-text",
        "reflect": false
      },
      "timeout": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "boolean | number",
          "resolved": "boolean | number",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "timeout",
        "reflect": false,
        "defaultValue": "false"
      }
    };
  }
  static get states() {
    return {
      "displayAlert": {}
    };
  }
  static get elementRef() { return "host"; }
}
//# sourceMappingURL=aiba-alert.js.map
